export default __webpack_public_path__ + "static/media/plus.d3d08da5.svg";